
export function generateFilePaths(parameters :{customerId: string}): {
  profilePicturePath: string;
} {
  const profilePicturePath = `customers/profilePicture/${parameters.customerId}`;
  return {
    profilePicturePath,
  };
}



